<div class="rejected-container">
  <h3 class="h-main h-main-medium corporate colapse-h">{{ 'your_mortgage_title' | translate }}</h3>

  <section class="col-12 rejected">
    <h4>{{ 'rejected_mortgage_title' | translate }}</h4>
    <p class="msg-info text-generic">{{ 'rejected_mortgage_summary' | translate }}</p>
    <div class="content-reasons">
      <p class="msg-reason-title">{{ 'rejected_mortgage_reasons_rejection' | translate }}</p>
      <p class="msg-reason" *ngFor="let reason of listRejectReasons">{{ reason | translate }}</p>
    </div>

    @if (listDocuments$ | async; as listDocuments) {
      <div class="content-documents">
        @if (listDocuments?.length > 0) {
          <h4 class="text-generic">
            {{ 'rejected_mortgage_list_documents' | translate }}
          </h4>
        }
        <div class="row files-list-items" *ngFor="let document of listDocuments">
          <div class="col-10 no-pd">
            <p class="">{{ document?.name }}</p>
          </div>
          <div class="col-2 content-actions-file download-file">
            @if (!document['downloading']) {
              <img
                class="icon-download"
                title="Descargar fichero"
                id="upload-file-btn-download"
                src="./assets/img/descargar.svg"
                id="upload-file-btn-download"
                src="./assets/img/descargar.svg"
                (click)="downloadFile(document)"
              />
            } @else {
              <img class="icon-download" title="Descargando fichero" src="./assets/img/loading-descarga.svg" />
            }
          </div>
        </div>
      </div>
    }
  </section>
</div>
